import { useCallback, useEffect, useState } from "preact/hooks";
import useAxios from "../../hooks/useAxios";
import { getDefaultStateParams } from "./TransactionsUtils";
import moment from "moment-timezone";

export default function useTransactions() {

    const { data: transactions, fetch } = useAxios();
    const { queryParams, paginationParams, newQueryParams } = getDefaultStateParams();
    const [isLoading, setIsLoading] = useState(false);

    const fetchTransactions = useCallback(async (config) => {

        setIsLoading(true);
        const current_limit = config?.params?.recordsPerPage;
        const current_offset = config?.params?.pageNumber * config?.params.recordsPerPage;

        const queryParams = {
            limit: current_limit,
            offset: current_offset,
            date_from: moment(config?.params?.dateFrom * 1000).tz("Asia/Almaty").format("YYYY-MM-DD HH:mm:ss"),
            date_to: moment(config?.params?.dateTo * 1000).tz("Asia/Almaty").format("YYYY-MM-DD HH:mm:ss"),
            sort: config?.params?.sort || 'created_at:desc',
        };

        const searchFilters = {
            flow_id: config?.params?.searchByFlowID,
            person_id: config?.params?.searchByPersonID,
            iin: config?.params?.searchByIIN ? `like:${config.params.searchByIIN}` : null,
        };

        Object.entries(searchFilters).forEach(([key, value]) => {
            if (value) queryParams[key] = value;
        });

        config?.params?.selectedFilters.forEach(([filter_type, value]) => {
            if (queryParams[filter_type] !== undefined) {
                queryParams[filter_type] += `,${value}`;
            } else {
                queryParams[filter_type] = "in:" + value;
            }
        });

        fetch("/user/journal/sessions/group-by-flow-id", {
            method: "GET",
            params: queryParams
        }).then((response) => {
            setIsLoading(false);
        });

    }, []);

    useEffect(() => {
        setIsLoading(true);
        fetch("/user/journal/sessions/group-by-flow-id", {

            method: "GET",
            params: {
                limit: paginationParams.defaultPageSize,
                offset: paginationParams.initialPageIndex * paginationParams.defaultPageSize,
                date_from: moment(newQueryParams.default_date_from.unix() * 1000).tz("Asia/Almaty").format("YYYY-MM-DD HH:mm:ss"),
                date_to: moment(newQueryParams.default_date_to.unix() * 1000).tz("Asia/Almaty").format("YYYY-MM-DD HH:mm:ss"),
                sort: 'created_at:desc',
            }

        }).then((response) => {
            setIsLoading(false);
        });
    }, []);

    return { transactions, fetchTransactions, isLoading };
}